// redux/slices/sftpSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createSftpUser,
  getSiteSftpUsers,
  deleteSftpUser,
} from "../../services/SftpUser";

// Thunks
export const fetchSftpUsers = createAsyncThunk(
  "sftp/fetchUsers",
  async (siteId, { rejectWithValue }) => {
    try {
      const res = await getSiteSftpUsers(siteId);
      return res.data; // array of users
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const addSftpUser = createAsyncThunk(
  "sftp/addUser",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createSftpUser(payload);
      return res.data; // single created user
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const removeSftpUser = createAsyncThunk(
  "sftp/removeUser",
  async ({ siteId, username }, { rejectWithValue }) => {
    try {
      await deleteSftpUser(siteId, username);
      return { username };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

// Slice
const sftpSlice = createSlice({
  name: "sftp",
  initialState: {
    users: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetch users
      .addCase(fetchSftpUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSftpUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchSftpUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // add user
      .addCase(addSftpUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSftpUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users.push(action.payload);
      })
      .addCase(addSftpUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // remove user
      .addCase(removeSftpUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeSftpUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = state.users.filter(
          (user) => user.username !== action.payload.username,
        );
      })
      .addCase(removeSftpUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default sftpSlice.reducer;
